import { ColorPicker } from 'primereact/colorpicker';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { _ThemeColorsType } from '../../../constants/staticTypes';

type Props = {
    isDefaultTheme: boolean;
    setIsDefaultTheme: React.Dispatch<React.SetStateAction<boolean>>;
    customColors: _ThemeColorsType;
    setCustomColors: React.Dispatch<React.SetStateAction<_ThemeColorsType>>;
    defaultColors?: _ThemeColorsType;
    ThemePreviewComponent: React.ComponentType<{ themeColors: any }>;
};

export default function CommonThemeSelection({
    isDefaultTheme,
    setIsDefaultTheme,
    customColors,
    setCustomColors,
    defaultColors,
    ThemePreviewComponent,
}: Readonly<Props>) {
    const handleColorChange = (key: keyof typeof customColors, value: any) => {
        setCustomColors((prev: any) => ({ ...prev, [key]: value.startsWith('#') ? value : `#${value}` }));
    };

    const renderColorInput = (label: string, key: keyof typeof customColors) => (
        <div className="org-theme-color-input">
            <label>{label}</label>
            <div className="org-theme-color-controls">
                <ColorPicker
                    className="theme-color-picker me-2"
                    value={customColors[key]?.replace('#', '')}
                    onChange={(e) => handleColorChange(key, e.value)}
                />
                <InputText
                    className="custom-input-text p-inputtext-sm org-theme-color-input-text"
                    value={customColors[key] ?? ''}
                    onChange={(e) => handleColorChange(key, e.target.value)}
                />
            </div>
        </div>
    );

    return (
        <div className="org-theme-selection">
            <div className="org-theme-options">
                <div className={`org-theme-option ${isDefaultTheme ? 'selected-theme' : ''}`}>
                    <div className="org-theme-preview">
                        <ThemePreviewComponent themeColors={defaultColors} />
                    </div>
                    <div className="org-theme-option-header">
                        <RadioButton
                            inputId="default"
                            name="theme"
                            value="default"
                            onChange={() => setIsDefaultTheme(true)}
                            checked={isDefaultTheme}
                        />
                        <label className="ms-2" htmlFor="default">
                            Default
                        </label>
                    </div>
                </div>

                <div className={`org-theme-option ${!isDefaultTheme ? 'selected-theme' : ''}`}>
                    <div className="org-theme-preview">
                        <ThemePreviewComponent themeColors={customColors} />
                    </div>
                    <div className="org-theme-option-header">
                        <RadioButton
                            inputId="custom"
                            name="theme"
                            value="custom"
                            onChange={() => setIsDefaultTheme(false)}
                            checked={!isDefaultTheme}
                        />
                        <label className="ms-2" htmlFor="custom">
                            Customized
                        </label>
                    </div>
                </div>
            </div>
            {!isDefaultTheme && (
                <div className="org-theme-color-header ">
                    <label className="mb-2 d-block fw-bold">Customize your theme</label>
                    <p className="text-muted mb-3">Choose your primary and secondary colors for the theme</p>
                    <div className="org-theme-color-inputs d-flex justify-content-between">
                        {renderColorInput('Primary Color', 'primary')}
                        {renderColorInput('Secondary Color', 'secondary')}
                    </div>
                </div>
            )}
        </div>
    );
}
